module.exports = __webpack_public_path__ + "dae5629529340d6d836afa2abdd31542.woff2";